import { style } from '@vanilla-extract/css';

import { tokens } from './tipJarTheme.css';

export const note = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
});

export const header = style({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  gap: '12px',
});

export const label = style({
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: '16px',
  color: tokens.muted,
});

export const field = style({
  display: 'block',
  width: '100%',
  boxSizing: 'border-box',
  padding: '10px 14px',
  border: `1px solid ${tokens.line}`,
  borderRadius: tokens.fieldRadius,
  outline: 'none',
  background: tokens.surface,
  color: tokens.ink,
  font: 'inherit',
  // 16px keeps iOS from zooming the page when the field takes focus.
  fontSize: '16px',
  lineHeight: '24px',
  resize: 'vertical',
  transition: 'border-color 150ms ease, box-shadow 150ms ease',
  selectors: {
    '&::placeholder': { color: tokens.faint, opacity: 1 },
    '&:focus': { borderColor: tokens.primary, boxShadow: `0 0 0 3px ${tokens.focusRing}` },
  },
});

export const footer = style({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '12px',
  fontSize: '12px',
  lineHeight: '16px',
  color: tokens.muted,
});

export const privacy = style({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '6px',
  margin: 0,
});

export const privacyIcon = style({
  flexShrink: 0,
  marginTop: '2px',
});

export const count = style({
  flexShrink: 0,
  fontVariantNumeric: 'tabular-nums',
  selectors: {
    '&[data-full="true"]': { fontWeight: 600, color: tokens.ink },
  },
});

export const remove = style({
  flexShrink: 0,
});
